/**
 * @author       xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const Info = ({ fill, size = 13, ...rest }: IconProps) => {
  const { colors } = useTheme()
  const colorValue = fill ?? colors.text

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 13 13"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.51641 0.759175C7.65266 0.759175 8.76339 1.09611 9.70814 1.72737C10.6529 2.35864 11.3892 3.25587 11.8241 4.30563C12.2589 5.35538 12.3726 6.5105 12.151 7.62491C11.9293 8.73932 11.3822 9.76297 10.5787 10.5664C9.77526 11.3699 8.75161 11.917 7.6372 12.1387C6.52279 12.3604 5.36767 12.2466 4.31792 11.8118C3.26817 11.3769 2.37093 10.6406 1.73966 9.69584C1.1084 8.75109 0.771466 7.64037 0.771466 6.50412C0.771466 4.98047 1.37674 3.51922 2.45412 2.44183C3.53151 1.36444 4.99276 0.759175 6.51641 0.759175ZM6.51641 2.0731e-05C5.23032 -0.00322674 3.97216 0.375126 2.90118 1.0872C1.83019 1.79927 0.994511 2.81305 0.499904 4.00024C0.00529659 5.18743 -0.126009 6.49466 0.122606 7.7565C0.371221 9.01835 0.98858 10.1781 1.89655 11.0889C2.80453 11.9998 3.9623 12.6208 5.22335 12.8734C6.4844 13.126 7.79205 12.9988 8.98079 12.508C10.1695 12.0171 11.186 11.1846 11.9014 10.1159C12.6169 9.04718 12.9992 7.79022 13 6.50412C12.9978 4.78372 12.3146 3.13416 11.0996 1.91611C9.88464 0.698062 8.23681 0.0106315 6.51641 0.00412436V2.0731e-05Z"
        fill={colorValue}
      />
      <path
        d="M6.51644 10.2669C6.41632 10.2669 6.32029 10.2272 6.24949 10.1564C6.17869 10.0856 6.13892 9.98954 6.13892 9.88941V5.68329C6.13892 5.58262 6.17891 5.48607 6.25009 5.41489C6.32128 5.3437 6.41782 5.30371 6.51849 5.30371C6.61916 5.30371 6.71571 5.3437 6.78689 5.41489C6.85808 5.48607 6.89807 5.58262 6.89807 5.68329V9.88941C6.89807 9.93933 6.88817 9.98876 6.86895 10.0348C6.84972 10.0809 6.82154 10.1227 6.78605 10.1578C6.75056 10.1929 6.70845 10.2207 6.66217 10.2394C6.6159 10.2581 6.56636 10.2675 6.51644 10.2669Z"
        fill={colorValue}
      />
      <path
        d="M6.50002 4.40312C6.83544 4.40312 7.10735 4.13121 7.10735 3.7958C7.10735 3.46038 6.83544 3.18848 6.50002 3.18848C6.16461 3.18848 5.8927 3.46038 5.8927 3.7958C5.8927 4.13121 6.16461 4.40312 6.50002 4.40312Z"
        fill={colorValue}
      />
    </svg>
  )
}
